"use strict";
function object(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        throw new Error('Invalid data');
    return Object.fromEntries(Object.entries(value));
}
function array(value, limit = 100) { if (!Array.isArray(value) || value.length > limit)
    throw new Error('Invalid list'); return value; }
function text(value, limit = 500) { if (typeof value !== 'string' || value.length > limit)
    throw new Error('Invalid text'); return value; }
function integer(value, max = Number.MAX_SAFE_INTEGER) { if (typeof value !== 'number' || !Number.isSafeInteger(value) || value < 0 || value > max)
    throw new Error('Invalid number'); return value; }
function flag(value) { if (typeof value !== 'boolean')
    throw new Error('Invalid flag'); return value; }
function imageUrl(value) {
    const result = new URL(text(value, 3000), location.origin);
    if (!['https:', 'http:'].includes(result.protocol) || !(result.hostname === location.hostname || result.hostname === 'cdn.shopify.com' || result.hostname.endsWith('.shopifycdn.com')))
        throw new Error('Invalid image');
    return result.href;
}
function variant(value) {
    const v = object(value);
    const id = integer(v.id);
    if (id === 0)
        throw new Error('Invalid variant');
    return { id, price: integer(v.price), compare: v.compare_at_price === null ? 0 : integer(v.compare_at_price), available: flag(v.available), options: array(v.options, 3).map(x => text(x, 100)), image: v.featured_image === null || v.featured_image === undefined ? 0 : integer(object(v.featured_image).id) };
}
function cart(value) {
    const c = object(value);
    return { total: integer(c.total_price), count: integer(c.item_count, 10000), currency: text(c.currency, 3), items: array(c.items).map(raw => {
            const i = object(raw);
            return { key: text(i.key, 200), id: integer(i.variant_id), title: text(i.product_title, 200), variant: i.variant_title === null ? '' : text(i.variant_title, 300), quantity: integer(i.quantity, 1000), price: integer(i.final_line_price), image: i.image === null ? null : imageUrl(i.image) };
        }) };
}
function node(tag, value) { const result = document.createElement(tag); if (value)
    result.textContent = value; return result; }
function format(price, currency = 'ILS') { return new Intl.NumberFormat('he-IL', { style: 'currency', currency }).format(price / 100); }
const messagesElement = document.getElementById('hugger-messages');
const messages = messagesElement ? object(JSON.parse(messagesElement.textContent || '{}')) : {};
const message = (key) => text(messages[key] ?? key, 300);
const dataElement = document.getElementById('hugger-product-data');
const product = dataElement ? { variants: array(object(JSON.parse(dataElement.textContent || '{}')).variants, 100).map(variant) } : null;
const extraElement = document.getElementById('hugger-extra-data');
const extras = extraElement ? array(JSON.parse(extraElement.textContent || '[]'), 20).map(raw => { const e = object(raw); const url = text(e.url, 500); if (!url.startsWith('/products/') || url.includes('//'))
    throw new Error('Invalid product path'); return { id: integer(e.id), title: text(e.title, 200), price: integer(e.price), available: flag(e.available), url, image: imageUrl(e.image) }; }) : [];
const allowedIds = new Set([...(product?.variants.map(v => v.id) ?? []), ...extras.map(e => e.id)]);
const dialog = document.querySelector('[data-cart-dialog]');
if (!(dialog instanceof HTMLDialogElement))
    throw new Error('Missing cart');
const cartDialog = dialog;
const cartStatusElement = document.querySelector('[data-cart-status]');
const productStatus = document.querySelector('[data-product-status]');
function showStatus(target, value) { if (target)
    target.textContent = value; }
const localeRoot = document.documentElement.lang === 'he' ? '/' : '/';
let appliedDiscount = '';
function checkoutPath() { return localeRoot + 'checkout' + (appliedDiscount ? '?discount=' + encodeURIComponent(appliedDiscount) : ''); }
async function request(path, body) {
    if (!/^cart\/(?:add|change|update)\.js$/.test(path) && path !== 'cart.js')
        throw new Error('Invalid cart route');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
        const response = await fetch(localeRoot + path, { method: body === undefined ? 'GET' : 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', signal: controller.signal, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
        if (!response.ok)
            throw new Error(`Cart HTTP ${response.status} ${path}`);
        return await response.json();
    }
    finally {
        clearTimeout(timeout);
    }
}
let busy = false;
let currentCart = null;
let selected = product?.variants.find(v => v.available) ?? product?.variants[0];
function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-add-button],[data-buy-now],[data-sticky-add],[data-add-extra]').forEach(el => { if (el instanceof HTMLButtonElement)
        el.disabled = value || (el.matches('[data-add-button],[data-buy-now],[data-sticky-add]') && !selected?.available); });
    const checkout = document.querySelector('.cart-summary a');
    if (checkout instanceof HTMLAnchorElement) {
        const disabled = value || !currentCart?.count;
        checkout.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        checkout.tabIndex = disabled ? -1 : 0;
    }
}
function renderCart(value) {
    currentCart = value;
    const host = document.querySelector('[data-cart-items]');
    if (!host)
        return;
    host.replaceChildren();
    for (const item of value.items) {
        const row = node('article');
        row.className = 'cart-line';
        if (item.image) {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = item.title;
            row.append(img);
        }
        else
            row.append(node('span'));
        const content = node('div');
        content.append(node('h3', item.title), node('small', item.variant), node('strong', format(item.price, value.currency)));
        const controls = node('div');
        controls.className = 'cart-quantity';
        for (const [label, quantity] of [['−', item.quantity - 1], ['+', item.quantity + 1]]) {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = label;
            button.setAttribute('aria-label', `${label} ${item.title}`);
            button.addEventListener('click', () => { void change(item.key, quantity); });
            controls.append(button);
            if (label === '−')
                controls.append(node('span', String(item.quantity)));
        }
        const remove = document.createElement('button');
        remove.textContent = message('remove');
        remove.type = 'button';
        remove.addEventListener('click', () => { void change(item.key, 0); });
        content.append(controls, remove);
        row.append(content);
        host.append(row);
    }
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = String(value.count));
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = format(value.total, value.currency));
    const empty = document.querySelector('[data-cart-empty]');
    if (empty instanceof HTMLElement)
        empty.hidden = value.count > 0;
    const upsell = document.querySelector('[data-cart-upsells]');
    if (upsell) {
        upsell.replaceChildren();
        for (const e of extras.filter(e => e.available && !value.items.some(i => i.id === e.id)).slice(0, 2)) {
            const row = node('div');
            row.className = 'cart-upsell';
            const img = document.createElement('img');
            img.src = e.image;
            img.alt = e.title;
            const info = node('div');
            info.append(node('p', e.title), node('small', format(e.price)));
            const button = document.createElement('button');
            button.textContent = message('add');
            button.type = 'button';
            button.addEventListener('click', () => { void add(e.id, false); });
            row.append(img, info, button);
            upsell.append(row);
        }
    }
    const checkout = document.querySelector('.cart-summary a');
    if (checkout instanceof HTMLAnchorElement) {
        const disabled = busy || value.count === 0;
        checkout.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        checkout.tabIndex = disabled ? -1 : 0;
        checkout.href = checkoutPath();
    }
}
async function refresh() { renderCart(cart(await request('cart.js'))); }
async function change(key, quantity) {
    if (busy)
        return;
    integer(quantity, 1000);
    if (!currentCart?.items.some(i => i.key === key))
        return;
    setBusy(true);
    try {
        renderCart(cart(await request('cart/change.js', { id: key, quantity })));
        showStatus(cartStatusElement, '');
    }
    catch (error) {
        console.error('[Hugger cart]', error instanceof Error ? error.message : 'Invalid response');
        try {
            await refresh();
        }
        catch {
            location.assign(localeRoot + 'cart');
        }
        showStatus(cartStatusElement, message('error'));
    }
    finally {
        setBusy(false);
    }
}
async function add(id, checkout) {
    if (busy || !allowedIds.has(id))
        return;
    setBusy(true);
    showStatus(productStatus, message('loading'));
    let added = false;
    try {
        await request('cart/add.js', { items: [{ id, quantity: 1 }] });
        added = true;
        if (checkout) {
            location.assign(checkoutPath());
            return;
        }
        await refresh();
        cartDialog.showModal();
        showStatus(productStatus, message('added'));
        showStatus(cartStatusElement, '');
    }
    catch {
        if (added) {
            location.assign(localeRoot + 'cart');
            return;
        }
        showStatus(productStatus, message('error'));
        showStatus(cartStatusElement, message('error'));
    }
    finally {
        setBusy(false);
    }
}
function updateVariant() {
    if (!product)
        return;
    const choices = [...document.querySelectorAll('input[data-option-index]:checked')].filter((el) => el instanceof HTMLInputElement).sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
    selected = product.variants.find(v => v.options.length === choices.length && v.options.every((o, i) => o === choices[i]?.value));
    if (selected)
        showImage(selected.image);
    choices.forEach(input => { const label = document.querySelector(`[data-option-name="${input.dataset.optionIndex}"]`); if (label)
        label.textContent = input.value; });
    const values = choices.map(input => input.value);
    document.querySelectorAll('input[data-option-index]').forEach(el => {
        if (!(el instanceof HTMLInputElement))
            return;
        const index = Number(el.dataset.optionIndex);
        const wanted = values.map((value, i) => i === index ? el.value : value);
        const candidate = product.variants.find(v => v.options.length === wanted.length && v.options.every((o, i) => o === wanted[i]));
        const card = el.closest('[data-option-card]');
        if (!card)
            return;
        card.classList.toggle('is-disabled', !candidate?.available);
        const price = card.querySelector('[data-bundle-price]');
        if (price)
            price.textContent = candidate ? format(candidate.price) : '';
        const compare = card.querySelector('[data-bundle-compare]');
        if (compare)
            compare.textContent = candidate && candidate.compare > candidate.price ? format(candidate.compare) : '';
    });
    const id = document.querySelector('[data-variant-id]');
    if (id instanceof HTMLInputElement)
        id.value = selected ? String(selected.id) : '';
    document.querySelectorAll('[data-variant-price],[data-sticky-price]').forEach(el => el.textContent = selected ? format(selected.price) : '');
    const compare = document.querySelector('[data-compare-price]');
    if (compare)
        compare.textContent = selected && selected.compare > selected.price ? format(selected.compare) : '';
    document.querySelectorAll('[data-availability]').forEach(el => el.textContent = selected?.available ? '' : message('unavailable'));
    setBusy(busy);
    showStatus(productStatus, '');
}
document.querySelectorAll('input[data-option-index]').forEach(el => el.addEventListener('change', updateVariant));
document.querySelector('[data-product-root] form')?.addEventListener('submit', e => { e.preventDefault(); if (selected?.available)
    void add(selected.id, false); });
document.querySelector('[data-buy-now]')?.addEventListener('click', () => { if (selected?.available)
    void add(selected.id, true); });
document.querySelector('[data-sticky-add]')?.addEventListener('click', () => { if (selected?.available)
    void add(selected.id, false); });
document.querySelectorAll('[data-add-extra]').forEach(el => el.addEventListener('click', () => { if (!(el instanceof HTMLElement))
    return; const id = Number(el.dataset.addExtra); if (Number.isSafeInteger(id))
    void add(id, false); }));
document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', async () => { cartDialog.showModal(); try {
    await refresh();
}
catch (error) {
    console.error('[Hugger cart]', error instanceof Error ? error.message : 'Invalid response');
    showStatus(cartStatusElement, message('error'));
} }));
cartDialog.addEventListener('click', e => { if (e.target === cartDialog) {
    const box = cartDialog.getBoundingClientRect();
    if (e.clientX < box.left || e.clientX > box.right)
        cartDialog.close();
} });
document.querySelector('.cart-summary a')?.addEventListener('click', e => { if (busy || !currentCart?.count)
    e.preventDefault(); });
document.querySelector('[data-discount-form]')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (busy)
        return;
    const input = document.getElementById('cart-discount');
    if (!(input instanceof HTMLInputElement))
        return;
    const discount = input.value.trim();
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(discount)) {
        showStatus(cartStatusElement, message('error'));
        return;
    }
    setBusy(true);
    try {
        const updated = cart(await request('cart/update.js', { discount }));
        appliedDiscount = discount;
        renderCart(updated);
        showStatus(cartStatusElement, message('discount_saved'));
    }
    catch (error) {
        console.error('[Hugger cart]', error instanceof Error ? error.message : 'Invalid response');
        showStatus(cartStatusElement, message('error'));
    }
    finally {
        setBusy(false);
    }
});
document.querySelector('[data-menu]')?.addEventListener('click', () => { const menu = document.querySelector('[data-menu-panel]'); if (menu instanceof HTMLElement)
    menu.hidden = !menu.hidden; });
const gallery = document.querySelector('.gallery-grid');
document.querySelectorAll('[data-slide]').forEach(el => el.addEventListener('click', () => { if (!(el instanceof HTMLElement) || !(gallery instanceof HTMLElement))
    return; const index = Number(el.dataset.slide); if (!Number.isSafeInteger(index) || index < 0 || index >= gallery.children.length)
    return; gallery.scrollTo({ left: gallery.clientWidth * index, behavior: 'auto' }); document.querySelectorAll('[data-slide]').forEach(dot => dot.setAttribute('aria-current', dot === el ? 'true' : 'false')); }));
let shownImage = 0;
function showImage(id) {
    if (id === 0 || id === shownImage || !(gallery instanceof HTMLElement))
        return;
    const slide = gallery.querySelector(`[data-image-id="${id}"]`);
    if (!(slide instanceof HTMLElement))
        return;
    shownImage = id;
    if (slide === gallery.firstElementChild)
        return;
    gallery.prepend(slide);
    gallery.scrollTo({ left: 0, behavior: 'auto' });
    const thumbs = document.querySelector('.gallery-thumbs');
    const thumb = thumbs?.querySelector(`[data-image-id="${id}"]`);
    if (thumbs && thumb) {
        thumbs.prepend(thumb);
        thumbs.scrollTo({ left: 0, behavior: 'auto' });
        thumbs.querySelectorAll('[data-slide]').forEach((dot, i) => { if (dot instanceof HTMLElement) {
            dot.dataset.slide = String(i);
            dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        } });
    }
}
if (gallery instanceof HTMLElement)
    gallery.addEventListener('scroll', () => { const index = Math.round(gallery.scrollLeft / gallery.clientWidth); document.querySelectorAll('[data-slide]').forEach(dot => { const active = dot instanceof HTMLElement && Number(dot.dataset.slide) === index; dot.setAttribute('aria-current', active ? 'true' : 'false'); if (active && dot instanceof HTMLElement && dot.parentElement)
        dot.parentElement.scrollTo({ left: dot.offsetLeft - dot.parentElement.offsetLeft - 20, behavior: 'smooth' }); }); }, { passive: true });
updateVariant();
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const addButton = document.querySelector('[data-add-button]');
const sticky = document.querySelector('[data-sticky]');
if (addButton && sticky && 'IntersectionObserver' in window)
    new IntersectionObserver(entries => { for (const entry of entries)
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0); }).observe(addButton);
document.querySelectorAll('[data-slider]').forEach(slider => {
    const track = slider.querySelector('[data-slider-track]');
    const dots = slider.querySelector('[data-slider-dots]');
    if (!(track instanceof HTMLElement) || !dots)
        return;
    const slides = [...track.children].filter((el) => el instanceof HTMLElement);
    if (slides.length < 2)
        return;
    const nearest = () => { const edge = track.getBoundingClientRect(); let best = 0, distance = Infinity; slides.forEach((slide, i) => { const box = slide.getBoundingClientRect(); const gap = Math.abs(box.left + box.width / 2 - edge.left - edge.width / 2); if (gap < distance) {
        distance = gap;
        best = i;
    } }); return best; };
    const buttons = slides.map((slide, i) => { const button = document.createElement('button'); button.type = 'button'; button.setAttribute('aria-label', String(i + 1)); button.addEventListener('click', () => slide.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' })); dots.append(button); return button; });
    const mark = () => { const current = nearest(); buttons.forEach((button, i) => button.setAttribute('aria-current', i === current ? 'true' : 'false')); };
    track.addEventListener('scroll', mark, { passive: true });
    mark();
});
if ('IntersectionObserver' in window) {
    const videos = [...document.querySelectorAll('video[data-autoplay]')].filter((el) => el instanceof HTMLVideoElement);
    if (reducedMotion)
        videos.forEach(video => { video.controls = true; });
    else {
        const watcher = new IntersectionObserver(entries => { for (const entry of entries) {
            const video = entry.target;
            if (!(video instanceof HTMLVideoElement))
                continue;
            if (entry.isIntersecting)
                void video.play().catch(error => { if (error instanceof DOMException && error.name === 'NotAllowedError')
                    video.controls = true; });
            else
                video.pause();
        } }, { threshold: .35 });
        videos.forEach(video => watcher.observe(video));
    }
}
const reviewRoot = document.querySelector('[data-reviews]');
function reviewMessages() { const el = document.getElementById('hugger-review-messages'); return el ? object(JSON.parse(el.textContent || '{}')) : {}; }
function stars(rating, label) { const el = node('span', '★'.repeat(rating) + '☆'.repeat(5 - rating)); el.className = 'stars'; el.setAttribute('role', 'img'); el.setAttribute('aria-label', `${rating} ${label}`); return el; }
async function loadReviews(root) {
    const words = reviewMessages();
    const word = (key) => text(words[key] ?? key, 200);
    const list = root.querySelector('[data-reviews-list]');
    const pages = root.querySelector('[data-reviews-pages]');
    if (!list || !pages)
        return;
    const source = new URL(text(root.dataset.reviewsUrl, 3000), location.origin);
    if (source.hostname !== location.hostname && source.hostname !== 'cdn.shopify.com')
        throw new Error('Invalid reviews source');
    const imagesElement = document.getElementById('hugger-review-images');
    const images = imagesElement ? array(JSON.parse(imagesElement.textContent || '[]'), 20).map(imageUrl) : [];
    const response = await fetch(source.href, { credentials: 'omit' });
    if (!response.ok)
        throw new Error(`Reviews HTTP ${response.status}`);
    const reviews = array(object(await response.json()).reviews, 1000).map((raw, order) => { const r = object(raw); const rating = integer(r.r, 5); if (rating < 1)
        throw new Error('Invalid rating'); const photo = r.p === undefined ? 0 : integer(r.p, images.length); return { author: text(r.a, 120), rating, title: text(r.t, 300), body: text(r.b, 4000), photo, order }; });
    const average = root.querySelector('[data-reviews-average]');
    if (average && reviews.length)
        average.textContent = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(2);
    const histogram = root.querySelector('[data-reviews-histogram]');
    if (histogram)
        for (let rating = 5; rating >= 1; rating--) {
            const count = reviews.filter(r => r.rating === rating).length;
            const row = node('div');
            row.className = 'histogram-row';
            const bar = node('span');
            bar.className = 'histogram-bar';
            const fill = node('i');
            fill.style.width = `${reviews.length ? Math.round(count / reviews.length * 100) : 0}%`;
            bar.append(fill);
            row.append(stars(rating, word('stars')), bar, node('small', String(count)));
            histogram.append(row);
        }
    const viewer = document.createElement('dialog');
    viewer.className = 'photo-dialog';
    const viewerImage = document.createElement('img');
    viewerImage.alt = word('photo');
    viewer.append(viewerImage);
    viewer.addEventListener('click', () => viewer.close());
    document.body.append(viewer);
    const photoButton = (review) => { const button = document.createElement('button'); button.type = 'button'; button.className = 'review-photo'; const img = document.createElement('img'); const src = images[review.photo - 1]; if (src)
        img.src = src; img.alt = word('photo'); img.loading = 'lazy'; button.append(img); button.addEventListener('click', () => { if (src) {
        viewerImage.src = src;
        viewer.showModal();
    } }); return button; };
    const gallery = root.querySelector('[data-reviews-photos]');
    if (gallery)
        for (const review of reviews.filter(r => r.photo > 0))
            gallery.append(photoButton(review));
    const perPage = 10;
    let sorted = reviews;
    let page = 1;
    const render = (focus) => {
        list.replaceChildren();
        for (const review of sorted.slice((page - 1) * perPage, page * perPage)) {
            const item = node('article');
            item.className = 'review';
            const who = node('p');
            who.className = 'review-author';
            const avatar = node('i');
            avatar.className = 'review-avatar';
            avatar.setAttribute('aria-hidden', 'true');
            const badge = node('em', word('verified'));
            who.append(avatar, node('span', review.author), badge);
            item.append(stars(review.rating, word('stars')), who);
            if (review.title)
                item.append(node('h3', review.title));
            if (review.body)
                item.append(node('p', review.body));
            if (review.photo > 0)
                item.append(photoButton(review));
            list.append(item);
        }
        const last = Math.max(1, Math.ceil(sorted.length / perPage));
        pages.replaceChildren();
        const link = (label, target, name, current = false) => { const button = document.createElement('button'); button.type = 'button'; button.textContent = label; button.setAttribute('aria-label', name); if (current)
            button.setAttribute('aria-current', 'page'); button.addEventListener('click', () => { page = target; render(true); }); pages.append(button); };
        if (page > 1)
            link('›', page - 1, word('previous'));
        for (let n = Math.max(1, Math.min(page - 1, last - 2)); n <= Math.min(last, Math.max(page + 1, 3)); n++)
            link(String(n), n, `${word('page')} ${n}`, n === page);
        if (page < last)
            link('‹', page + 1, word('next'));
        if (focus)
            root.querySelector('[data-reviews-sort]')?.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    const sort = root.querySelector('[data-reviews-sort]');
    if (sort instanceof HTMLSelectElement)
        sort.addEventListener('change', () => {
            const by = sort.value;
            sorted = [...reviews].sort((a, b) => by === 'high' ? b.rating - a.rating || a.order - b.order : by === 'low' ? a.rating - b.rating || a.order - b.order : by === 'photos' ? Number(b.photo > 0) - Number(a.photo > 0) || a.order - b.order : a.order - b.order);
            page = 1;
            render(false);
        });
    render(false);
}
if (reviewRoot instanceof HTMLElement) {
    const start = () => { loadReviews(reviewRoot).catch(error => { console.error('[Hugger reviews]', error instanceof Error ? error.message : 'Invalid response'); const list = reviewRoot.querySelector('[data-reviews-list]'); if (list)
        list.textContent = text(reviewMessages().error ?? '', 300); }); };
    if ('IntersectionObserver' in window) {
        const watcher = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) {
            watcher.disconnect();
            start();
        } }, { rootMargin: '800px 0px' });
        watcher.observe(reviewRoot);
    }
    else
        start();
}
